import React from 'react';
import { IClassName } from '../../../constants';

const AuditPLogo: React.FC<IClassName> = ({ className }) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path d="M18.3334 8.33317V12.4998C18.3334 16.6665 16.6667 18.3332 12.5001 18.3332H7.50008C3.33341 18.3332 1.66675 16.6665 1.66675 12.4998V7.49984C1.66675 3.33317 3.33341 1.6665 7.50008 1.6665H11.6667" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M18.3334 8.33317H15.0001C12.5001 8.33317 11.6667 7.49984 11.6667 4.99984V1.6665L18.3334 8.33317Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M5.83325 10.8335H10.8333" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M5.83325 14.1665H9.16659" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>

  );
};

export default AuditPLogo;
